import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchStockHistory } from '../../../../../../../../jsx/actions/transferAction';
import { TableLayout } from '../../containers/Layout';
import { TableRow, TableCell, Typography, TableHead, TableBody, TableFooter, Box } from '@material-ui/core';
import { isEmpty } from 'lodash-es';
import { amber, blue, blueGrey, cyan, green, indigo, purple, red, orange, lightGreen } from '@material-ui/core/colors';
import { toast } from 'react-toastify';

const SingleHistory = (props) => {
    const dispatch = useDispatch();
    const CLIENTS = useSelector((state) => state.inventory.clients); 
    const AGENTS = useSelector((state) => state.inventory.agents); 
    const SHOPS = useSelector((state) => state.inventory.shops); 

	// const PRODUCTS = useSelector((state) => state.inventory.OPucts); 
    const [history, setHistory] = useState([]);
    const [shop, setShop] = useState("");
    const [OPuct, setProduct] = useState("");

    useEffect(() => {
        const fetchData = async () => {
            try {
                const list = await dispatch(fetchStockHistory(props.stockID));
                console.log('====================================');
                console.log({list});
                console.log('====================================');
                if (typeof list === "undefined"){
                    toast.error("Error SingleHistory - catch List")
                }else{
                    setHistory(list);
                }
            } catch (error) {
                console.error('Error fetching history details:', error);
            }
        };
        fetchData();
        const info = props.stockID.split("|")
        setShop(info[0])
        setProduct(info[1])
    }, [dispatch, props.stockID]);

    
        
    const findHistory = () => {
        let found = false
        let stockList = []
        if(history && history.length > 0){
            history.map( OP => {
                // Skip items created automatically during transfer splits
                // These are fragments and should not be displayed separately
                if (OP.created_by && OP.created_from_history) {
                    return;
                }

                found = true

                let style = {
                    background: red[100]
                }
                const rawTransferType = OP.transfer_type
                let entry = OP.in_shop == shop

                if (rawTransferType === "reapprovisionnement" ){
                    OP.transfer_type = "reappro"

                    // OP.source = SHOPS[OP.shop_dest] ?  SHOPS[OP.shop_dest].name : ""
                } else if (rawTransferType === "reapprovisionnement_ext" ){
                    OP.transfer_type = "reappro_ext"
                } else if (rawTransferType === "commercial_return" ){
                    OP.transfer_type = "retour_com"
                    style.background = green[100] 
                } else if (OP.type === "resa"){
                    style.background = purple[100]
                    OP.transfer_type = "reservation"
                } else if (OP.type === "installation"){
                    style.background = amber[100]
                    OP.transfer_type = "installation"
                } else if (OP.type === "arrivage"){
                    style.background = cyan[100]
                    OP.transfer_type = "arrivage"
                } else if (OP.type === "demand"){
                    style.background = indigo[100]
                    OP.transfer_type = "demand"
                } else if (OP.transfer_type === "sav"){
                    style.background = blueGrey[100]
                } else if (OP.transfer_type === "payg" || OP.transfer_type === "commercial"){
                    style.background = blue[100]
                    entry = false
                // } else if (OP.transfer_type === "prepa"){
                //     style.background = yellow[100]
                } else if ( OP.transfer_type === "achat") {
                    style.background = green[100] 
                } else if (OP.transfer_type === "vente") {
                    entry = false
                }

                // OP.prix_revient = (OP.priceHT * OP.surcout)

                if (!!OP.surcout || OP.transfer_type === "retour_com"){
                    style.fontWeight = 700
                }

                if (!isEmpty(OP.client_id)) {
                    OP.client = CLIENTS && CLIENTS[OP.client_id] ? CLIENTS[OP.client_id].client_lastname : ""
                } else if (!isEmpty(OP.commercial_id)) {
                    OP.client = AGENTS && AGENTS[OP.commercial_id] ? AGENTS[OP.commercial_id].name : ""
                } 
                if (OP.is_deleted) {
                    style.textDecoration = "line-through"
                    style.color = "dimgrey"
                    style.fontStyle = "italic"
                }                  
                if (typeof OP !== 'undefined' && OP.transfer_id !== undefined && OP.transfer_id.startsWith("AV_")) {
                    OP.transfer_type = "avoir"
                    style.fontStyle = "italic"
                }                  
                if (OP.transfer_type === "reappro") {
                    const isReapproExit = OP.from_shop && OP.from_shop === shop
                    if (isReapproExit) {
                        entry = false
                        OP.transfer_type = "reappro_sortie"
                        style.background = orange[100]
                    } else if (OP.in_shop === shop) {
                        entry = true
                        OP.transfer_type = "reappro_entree"
                        style.background = lightGreen[100]
                    }
                }

                stockList.push({
                    entry,
                    item: OP,
                    style
                })
                        // console.log("okay, op exists", OP);
            })
            
            console.log("HISTORY TABLE", stockList);
            
            return[
                stockList.map( OP => {
                    switch (OP.item.transfer_type) {
                        case "achat":
                            return ( 
                            <TableRow style={OP.style} key={OP.item.id}>
                                    <TableCell style={OP.style}>{(new Date(OP.item.creation_date)).toLocaleString('fr-FR')}</TableCell>                        
                                    <TableCell style={OP.style}>{OP.item.transfer_type}</TableCell>
                                    <TableCell style={OP.style}>{OP.entry ? OP.item.quantity : (OP.item.quantity * -1) }</TableCell>
                                    <TableCell style={OP.style}>{SHOPS && SHOPS[OP.item.in_shop] ?  SHOPS[OP.item.in_shop].name : ""}</TableCell> 
                                    {/* <TableCell style={OP.style}>{OP.entry ? Math.round(OP.item.price_ttc).toLocaleString("fr-FR") : ""}</TableCell> */}
                                </TableRow>
                            )
                            break;
                        default:
                            return (        
                                <TableRow style={OP.style} key={OP.item.id}>
                                    <TableCell style={OP.style}>{(new Date(OP.item.creation_date)).toLocaleString('fr-FR')}</TableCell>                        
                                    <TableCell style={OP.style}>{OP.item.transfer_type}</TableCell>
                                    <TableCell style={OP.style}>{OP.entry ? OP.item.quantity : (OP.item.quantity * -1) }</TableCell>
                                    <TableCell style={OP.style}>{OP.item.client}</TableCell> 
                                    {/* <TableCell style={OP.style}>{OP.entry ? Math.round(OP.item.price_ttc).toLocaleString("fr-FR") : ""}</TableCell> */}
                                </TableRow>
                            )
                            break;
                    }

                }),
                found
            ]
        } else {
            return ["", false]
        }
    }
      
    return (
        <TableLayout>
            <TableHead>
                <TableRow>
                    <TableCell>Date</TableCell>
                    <TableCell>Nature</TableCell>
                    <TableCell>Quantité</TableCell>
                    <TableCell>Client / Commercial / Destination</TableCell>
                    {/* <TableCell>Prix</TableCell> */}
                    
                </TableRow>
            </TableHead>
            <TableBody>
                {findHistory()[0]}
            </TableBody>
        </TableLayout>
    );
}

export default SingleHistory;